class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.checkFilterGroups();
  }

  checkFilterGroups() {
    var filterGroups = this.querySelectorAll('.filter__list-group');

    if (filterGroups) {
      filterGroups.forEach((group) => {
        if (group.querySelectorAll('.filter__item').length == 0) {
          group.classList.add('hidden');
        } else {
          group.classList.remove('hidden');
        }
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams.replace(/filter.v.availability=1/g, '');

    if (searchParams.indexOf('filter.p.m') > -1 || searchParams.indexOf('filter.v.option') > -1) {
      searchParams += '&filter.v.availability=1';
    }

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document.getElementById('ProductGridContainer').querySelector('.listing').classList.add('loading');

    const countContainer = document.getElementById('ProductCount');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    if (typeof initRcContentActive === 'function') {
      initRcContentActive();
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        Wishlist.loadButtons();

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    Wishlist.loadButtons();

    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('.filter__group');

    facetDetailsElements.forEach((element) => {
      let id = element.id;
      let targetElement = document.getElementById(id);

      if (targetElement.hasAttribute('open')) {
        element.setAttribute('open', '');
      }

      targetElement.querySelector('.filter__group-menu').innerHTML = element.querySelector('.filter__group-menu').innerHTML;

      var filterGroups = targetElement.querySelectorAll('.filter__list-group');

      if (filterGroups) {
        filterGroups.forEach((group) => {
          if (group.querySelectorAll('.filter__item').length == 0) {
            group.remove();
          } else {
            group.classList.remove('hidden');
          }
        });
      }

      var filterList = targetElement.querySelector('.filter__group-menu .filter__list');

      if (filterList) {
        var isEmpty = filterList.innerHTML.trim() === '';

        if (isEmpty) {
          targetElement.parentElement.classList.add('hidden');
        } else {
          targetElement.parentElement.classList.remove('hidden');
        }
      }
    });

    const removeSource = parsedHTML.getElementById('FilterRemove');
    const removeTarget = document.getElementById('FilterRemove');

    if (removeSource && removeTarget) {
      removeTarget.innerHTML = removeSource.innerHTML;
    }

    const drawerRemoveSource = parsedHTML.getElementById('FilterDrawerRemove');
    const drawerRemoveTarget = document.getElementById('FilterDrawerRemove');

    if (drawerRemoveSource && drawerRemoveTarget) {
      drawerRemoveTarget.innerHTML = drawerRemoveSource.innerHTML;
    }

    if (typeof syncTopFilterClearAll === 'function') {
      syncTopFilterClearAll();
    }

    if (typeof initTopFilterClearAll === 'function') {
      initTopFilterClearAll();
    }

    const sortLabelSource = parsedHTML.querySelector('.filters-sort__label');
    const sortLabelTarget = document.querySelector('.filters-sort__label');

    if (sortLabelSource && sortLabelTarget) {
      sortLabelTarget.outerHTML = sortLabelSource.outerHTML;
    }

    if (typeof initFacetsFilterList === 'function') {
      initFacetsFilterList();
    }

    if (typeof toggleEmptyFacetsFilters === 'function') {
      toggleEmptyFacetsFilters();
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    const viewAsToggle = document.querySelector('view-as-toggle');
    if (viewAsToggle) viewAsToggle.reload();

    const viewByToggle = document.querySelector('view-by-toggle');
    if (viewByToggle) viewByToggle.reload();

    if (window.PaginationInfinite && typeof window.PaginationInfinite.init === 'function') {
      window.PaginationInfinite.init();
    }

    if (typeof ensureContentCardVideosPlay === 'function') ensureContentCardVideosPlay();

    //document.getElementById('product-grid').setAttribute('data-loaded', true);

    window.scrollTo(0, 0);
  }

  static renderProductCount(html) {
    //const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    //const container = document.getElementById('ProductCount');
    //container.innerHTML = count;
    //container.classList.remove('loading');

    const buttonCount = new DOMParser().parseFromString(html, 'text/html').getElementById('MenuDrawerApply').innerHTML;
    const documentButton = document.getElementById('MenuDrawerApply');
    documentButton.innerHTML = buttonCount;
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    /*
    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement.querySelectorAll('.facets__item.hidden').forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
    */
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
        forms.push(this.createSearchParams(form));
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    const targetUrl = new URL(event.currentTarget.href, window.location.origin);

    if (targetUrl.origin !== window.location.origin || targetUrl.pathname !== window.location.pathname) {
      window.location.assign(targetUrl.pathname + targetUrl.search + targetUrl.hash);
      return;
    }

    const url = targetUrl.search ? targetUrl.search.slice(1) : '';
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);

    setTimeout(() => {
      document.querySelectorAll('.content-list [data-href]').forEach((element) => {
        element.classList.remove('link');
        element.classList.add('full-unstyled-link');

        element.setAttribute('href', element.getAttribute('data-href'));
      });
    }, 500);
  }
}

customElements.define('facet-remove', FacetRemove);

class ViewByToggle extends HTMLElement {
  // Desktop and mobile column counts are paired by index — a single click advances
  // both simultaneously. Configure them together in the theme editor:
  //   "View as options (desktop)": "4,6,2"
  //   "View as options (mobile)":  "2,3,1"
  //
  // Index 0 → 4 col desktop / 2 col mobile
  // Index 1 → 6 col desktop / 3 col mobile
  // Index 2 → 2 col desktop / 1 col mobile
  //
  // If desktop and mobile should always show the same count, set identical values:
  //   desktop: "2,3,1"  mobile: "2,3,1"
  //
  // The selected index is persisted in localStorage('viewBy') and restored on every
  // page load, overriding the Liquid-rendered grid class from section.settings.columns_mobile.
  constructor() {
    super();

    this.index = parseInt(this.dataset.index);
    this.optionsDesktop = this.dataset.options.split(',');
    this.optionsMobile = this.dataset.optionsMobile.split(',');

    this.button = this.querySelector('button');

    this.desktopText = this.querySelector('.facets-toggle__option--desktop');
    this.mobileText = this.querySelector('.facets-toggle__option--mobile');

    this.productGrid = document.querySelector('#product-grid');

    this.button.addEventListener('click', this.toggleView.bind(this));

    this.init();

    this.load();
  }

  reload() {
    this.productGrid = document.querySelector('#product-grid');

    this.init();
    this.unload();
    this.load();
  }

  init() {
    if (localStorage.getItem('viewBy')) {
      this.index = parseInt(localStorage.getItem('viewBy'));
    }
  }

  unload() {
    this.productGrid.classList.remove(`grid--${this.optionsDesktop[this.index]}-col-desktop`);
    this.productGrid.classList.remove(`grid--${this.optionsMobile[this.index]}-col-tablet-down`);
  }

  load() {
    this.productGrid.classList.add(`grid--${this.optionsDesktop[this.index]}-col-desktop`);
    this.productGrid.classList.add(`grid--${this.optionsMobile[this.index]}-col-tablet-down`);

    this.desktopText.innerHTML = this.optionsDesktop[this.index];
    this.mobileText.innerHTML = this.optionsMobile[this.index];

    this.productGrid.setAttribute('data-loaded', true);
  }

  toggleView(e) {
    e.preventDefault();

    this.unload();

    this.index = (this.index + 1) % this.optionsDesktop.length;

    this.load();

    this.save();
  }

  save() {
    localStorage.setItem('viewBy', this.index);
  }
}

customElements.define('view-by-toggle', ViewByToggle);

class ViewAsToggle extends HTMLElement {
  constructor() {
    super();

    this.index = parseInt(this.dataset.index);
    this.options = this.dataset.options.split(',');

    this.button = this.querySelector('button');

    this.text = this.querySelector('.facets-toggle__option');

    this.productGrid = document.querySelector('#product-grid');

    this._heroObserver = null;
    // Queue of cards waiting for mobile enhancement, drained 2-per-rAF to
    // prevent burst DOM mutations + image decodes during rapid scroll/back-scroll.
    this._pendingHeroCards = [];
    this._heroInjectScheduled = false;

    this.button.addEventListener('click', this.toggleView.bind(this));

    this.init();

    this.load();

    // Single resize handler replaces per-slider ResizeObservers — previously
    // ~100 simultaneous initPages() calls on orientation change crashed iOS Safari.
    this._prevMobile = window.innerWidth < 750;
    this._orientationHandler = () => {
      const isMobile = window.innerWidth < 750;
      if (isMobile !== this._prevMobile) {
        this._prevMobile = isMobile;
        this.reload();
      }
    };
    window.addEventListener('resize', this._orientationHandler, { passive: true });
  }

  disconnectedCallback() {
    if (this._orientationHandler) {
      window.removeEventListener('resize', this._orientationHandler);
    }
    if (this._heroObserver) {
      this._heroObserver.disconnect();
      this._heroObserver = null;
    }
    this._pendingHeroCards = [];
    this._heroInjectScheduled = false;
  }

  reload() {
    this.productGrid = document.querySelector('#product-grid');
    this.init();
    this.unload();
    this.load();
  }

  getViewAs() {
    return this.options[this.index];
  }

  init() {
    if (localStorage.getItem('viewAs')) {
      this.index = parseInt(localStorage.getItem('viewAs'));
    }
  }

  unload() {
    const cards = this.productGrid.querySelectorAll('.card');

    cards.forEach((card) => {
      const media = card.querySelector(`.media--${this.options[this.index]}`);

      if (media) {
        media.classList.add('hidden');
      }
    });
  }

  _getFallbackStaticMedia(card) {
    return card.querySelector('.card__media > a > .media:not(.media--product):not(.media--model)');
  }

  _setStaticMediaVisibility(card, shouldShow) {
    const productMedia = card.querySelector('.media--product');
    const modelMedia = card.querySelector('.media--model');
    const fallbackMedia = this._getFallbackStaticMedia(card);

    if (productMedia || modelMedia) {
      if (productMedia) {
        productMedia.classList.toggle('hidden', !shouldShow || this.index !== 0);
      }
      if (modelMedia) {
        modelMedia.classList.toggle('hidden', !shouldShow || this.index !== 1);
      }
      return;
    }

    if (fallbackMedia) {
      fallbackMedia.classList.toggle('hidden', !shouldShow);
    }
  }

  _queueCardForEnhancement(card) {
    if (!card) return;
    if (card.dataset.mobileEnhanced === 'true' || card.dataset.mobileEnhanceQueued === 'true') return;

    card.dataset.mobileEnhanceQueued = 'true';
    this._pendingHeroCards.push(card);
    this._scheduleHeroInject();
  }

  _activateMobileCard(card, slidersToReset = null) {
    if (!card) return;

    const slider = card.querySelector('.content-slider');
    const sliderList = slider && slider.querySelector('[id^="Slider-"]');
    if (!slider || !sliderList) return;

    card.dataset.mobileEnhanceQueued = 'false';
    slider.classList.remove('scroll-trigger', 'animate--slide-in', 'hidden');
    this._setStaticMediaVisibility(card, false);
    this._injectHeroForCard(card);

    if (Array.isArray(slidersToReset)) {
      slidersToReset.push({ sliderList, slider });
    } else {
      sliderList.style.scrollBehavior = 'auto';
      sliderList.scrollLeft = 0;
      if (slider.dots !== undefined) {
        slider.dots = slider.querySelectorAll('.slider-counter__link');
      }
      if (typeof slider.resetPages === 'function') slider.resetPages();
    }

    card.dataset.mobileEnhancedView = String(this.index);
    card.dataset.mobileEnhanced = 'true';

    const cardSwatches = card.querySelector('card-swatches');
    if (cardSwatches && typeof cardSwatches.init === 'function') {
      cardSwatches.init();
    }
    if (cardSwatches && typeof cardSwatches.scheduleVisibleSwatchPrefetch === 'function') {
      cardSwatches.scheduleVisibleSwatchPrefetch();
    }
    // Play any videos in the slider (autoplay doesn't fire from display:none, and the
    // hero slide video is cloned via innerHTML so it needs an explicit play() call).
    if (cardSwatches && typeof cardSwatches.ensureCardVideoAutoplay === 'function') {
      sliderList.querySelectorAll('video').forEach((v) => cardSwatches.ensureCardVideoAutoplay(v));
    }
  }

  // Inject the hero slide (slide 0) DOM nodes for a single card.
  // Does NOT reset the slider — the caller is responsible for calling resetPages()
  // (either via the batched rAF in load() or individually for deferred cards).
  // Keeps loading="lazy" so iOS Safari can evict decoded bitmaps for off-screen cards,
  // preventing cumulative memory growth on large collections (120+ cards).
  _injectHeroForCard(card) {
    const slider = card.querySelector('.content-slider');
    const sliderList = slider && slider.querySelector('[id^="Slider-"]');
    if (!sliderList) return;

    const heroClass = this.index === 0 ? 'mobile-product-hero-slide' : 'mobile-model-hero-slide';
    if (sliderList.querySelector(`.${heroClass}`)) return; // already injected

    sliderList.querySelectorAll('.mobile-product-hero-slide, .mobile-model-hero-slide').forEach((el) => el.remove());
    const controlWrapper = slider.querySelector('.slideshow__control-wrapper');
    if (controlWrapper) controlWrapper.querySelectorAll('.mobile-hero-dot').forEach((el) => el.remove());

    const productId = sliderList.id.replace('Slider-', '');

    if (this.index === 0) {
      const productMedia = card.querySelector('.media--product');
      if (productMedia) {
        const slide = document.createElement('li');
        slide.id = `Slide-${productId}-0`;
        slide.className = 'content__item slider__slide mobile-product-hero-slide';
        const wrap = document.createElement('div');
        wrap.className = productMedia.className.replace('hidden', '').trim();
        wrap.innerHTML = productMedia.innerHTML;
        // Fix sizes attr: Liquid renders "100vw" for mobile but the card is
        // ~50vw in a 2-col grid. Without this, 3x DPR phones request the
        // original-resolution image (2000px+, ~20MB decoded) instead of the
        // 720w srcset variant (~3MB). This was the primary OOM crash cause.
        wrap.querySelectorAll('img').forEach((img) => {
          img.sizes = '(min-width: 750px) 25vw, 50vw';
        });
        slide.appendChild(wrap);
        sliderList.prepend(slide);
        if (controlWrapper) {
          const dot = document.createElement('button');
          dot.className = 'slider-counter__link slider-counter__link--dots link mobile-hero-dot';
          dot.setAttribute('aria-controls', sliderList.id);
          controlWrapper.prepend(dot);
        }
      }
    } else if (this.index === 1) {
      const modelMedia = card.querySelector('.media--model');
      const hasLifestyleMedia = modelMedia && modelMedia.dataset.hasLifestyleMedia === 'true';
      const firstLiquidSlide = sliderList.querySelector(`#Slide-${productId}-2`);
      if (!firstLiquidSlide || hasLifestyleMedia) {
        if (modelMedia) {
          const slide = document.createElement('li');
          slide.id = `Slide-${productId}-0`;
          slide.className = 'content__item slider__slide mobile-model-hero-slide';
          const wrap = document.createElement('div');
          wrap.className = modelMedia.className.replace('hidden', '').trim();
          wrap.innerHTML = modelMedia.innerHTML;
          wrap.querySelectorAll('img').forEach((img) => {
            img.sizes = '(min-width: 750px) 25vw, 50vw';
          });
          slide.appendChild(wrap);
          sliderList.prepend(slide);
          if (controlWrapper) {
            const dot = document.createElement('button');
            dot.className = 'slider-counter__link slider-counter__link--dots link mobile-hero-dot';
            dot.setAttribute('aria-controls', sliderList.id);
            controlWrapper.prepend(dot);
          }
        }
      }
    }
  }

  // Shared observer that keeps only a bounded mobile enhancement window around the
  // viewport. Cards entering the window are queued for enhancement; cards leaving it
  // are returned to a lightweight static state. Disconnected and recreated on each
  // load() call so view toggles start fresh.
  _getHeroObserver() {
    if (this._heroObserver) return this._heroObserver;
    this._heroObserver = new IntersectionObserver((entries) => {
      let queued = false;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this._queueCardForEnhancement(entry.target);
          queued = true;
        } else {
          this._deactivateMobileCard(entry.target);
        }
      });
      if (queued) this._scheduleHeroInject();
    }, { rootMargin: '400px 0px 400px 0px' });
    return this._heroObserver;
  }

  // Drain _pendingHeroCards at a rate of 2 cards per animation frame.
  // This spreads the DOM mutations + image decodes over multiple frames,
  // preventing iOS jetsam OOM spikes during rapid back-scroll.
  _scheduleHeroInject() {
    if (this._heroInjectScheduled) return;
    this._heroInjectScheduled = true;
    requestAnimationFrame(() => {
      this._heroInjectScheduled = false;
      let processed = 0;
      while (this._pendingHeroCards.length > 0 && processed < 2) {
        const card = this._pendingHeroCards.shift();
        if (!card || !document.body.contains(card)) continue;
        this._activateMobileCard(card);
        processed++;
      }
      // If more cards are queued, schedule another frame.
      if (this._pendingHeroCards.length > 0) this._scheduleHeroInject();
    });
  }

  _deactivateMobileCard(card) {
    if (!card) return;

    card.dataset.mobileEnhanceQueued = 'false';
    this._pendingHeroCards = this._pendingHeroCards.filter((pendingCard) => pendingCard !== card);

    const slider = card.querySelector('.content-slider');
    const sliderList = slider && slider.querySelector('[id^="Slider-"]');
    const controlWrapper = slider && slider.querySelector('.slideshow__control-wrapper');
    const cardSwatches = card.querySelector('card-swatches');
    if (cardSwatches && typeof cardSwatches.cancelVisibleSwatchPrefetch === 'function') {
      cardSwatches.cancelVisibleSwatchPrefetch();
    }
    const shouldResetCard =
      cardSwatches &&
      typeof cardSwatches._resetMobileSlider === 'function' &&
      (
        (cardSwatches.currentStyle && cardSwatches.originalStyle && cardSwatches.currentStyle !== cardSwatches.originalStyle) ||
        (sliderList && sliderList.scrollLeft > 0)
      );

    if (shouldResetCard) {
      cardSwatches._resetMobileSlider();
    }

    if (sliderList) {
      sliderList.style.scrollBehavior = 'auto';
      sliderList.scrollLeft = 0;
      sliderList.querySelectorAll('.mobile-product-hero-slide, .mobile-model-hero-slide').forEach((slide) => slide.remove());
    }

    if (controlWrapper) {
      controlWrapper.querySelectorAll('.mobile-hero-dot').forEach((dot) => dot.remove());
    }

    card.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
      } catch (e) {}
    });

    if (slider) {
      slider.classList.add('hidden');
    }

    this._setStaticMediaVisibility(card, true);
    card.dataset.mobileEnhanced = 'false';
  }

  load() {
    const cards = this.productGrid.querySelectorAll('.card');
    const isMobile = window.innerWidth < 750;
    const slidersToReset = [];

    // Reset observers and injection queue so view toggles start fresh.
    if (this._heroObserver) {
      this._heroObserver.disconnect();
      this._heroObserver = null;
    }
    this._pendingHeroCards = [];
    this._heroInjectScheduled = false;

    const viewportTop = -400;
    const viewportBottom = window.innerHeight + 400;

    cards.forEach((card) => {
      const media = card.querySelector(`.media--${this.options[this.index]}`);
      const slider = card.querySelector('.content-slider');

      if (isMobile) {
        const sliderList = slider && slider.querySelector('[id^="Slider-"]');
        if (sliderList) {
          this._getHeroObserver().observe(card);

          const cardRect = card.getBoundingClientRect();
          const isWithinEnhancementWindow = cardRect.top < viewportBottom && cardRect.bottom > viewportTop;

          if (isWithinEnhancementWindow) {
            const alreadyEnhanced = card.dataset.mobileEnhanced === 'true';
            const viewChanged = card.dataset.mobileEnhancedView !== String(this.index);
            // sliderIsHidden catches portrait→landscape→portrait: desktop load() adds
            // 'hidden' but doesn't deactivate, so on rotate-back the slider needs
            // re-activation even though mobileEnhanced is still 'true'.
            const sliderIsHidden = slider.classList.contains('hidden');

            if (!alreadyEnhanced || viewChanged || sliderIsHidden) {
              this._activateMobileCard(card, slidersToReset);
            }
          } else {
            this._deactivateMobileCard(card);
          }
        } else if (media) {
          media.classList.remove('hidden');
        }
      } else {
        // Desktop: show only the current view's media; unload() hides the other.
        // Do NOT touch the other static image — removing hidden from both
        // simultaneously causes them to stack on top of each other.
        // Skip cards currently being hovered — onCardEnter is authoritative for those.
        // Exception: simple cards skip onCardEnter, so always process them.
        if (card.matches(':hover') && !card.classList.contains('card--simple')) return;
        if (media) {
          media.classList.remove('hidden');
          const video = media.querySelector('video');
          if (video) {
            const cardSwatches = card.querySelector('card-swatches');
            if (cardSwatches && typeof cardSwatches.ensureCardVideoAutoplay === 'function') {
              cardSwatches.ensureCardVideoAutoplay(video);
            }
          }
        }
        if (slider) slider.classList.add('hidden');
      }

    });

    // Batch rAF only for the cards that were processed immediately.
    if (slidersToReset.length > 0) {
      requestAnimationFrame(() => {
        slidersToReset.forEach(({ sliderList, slider }) => {
          sliderList.style.scrollBehavior = 'auto';
          sliderList.scrollLeft = 0;
          if (slider.dots !== undefined) {
            slider.dots = slider.querySelectorAll('.slider-counter__link');
          }
          if (typeof slider.resetPages === 'function') slider.resetPages();
        });
      });
    }

    this.text.innerHTML = this.options[this.index];

    this.productGrid.setAttribute('data-loaded', true);
  }

  toggleView(e) {
    e.preventDefault();

    this.unload();

    this.index = (this.index + 1) % this.options.length;

    this.load();

    this.save();
  }

  save() {
    localStorage.setItem('viewAs', this.index);
  }
}

customElements.define('view-as-toggle', ViewAsToggle);

const toggleEmptyFacetsFilters = () => {
  document.querySelectorAll('.facets-filters').forEach((element) => {
    const hasContent = element.childElementCount > 0 || element.textContent.trim() !== '';
    element.hidden = !hasContent;
  });
};

const getTopFilterClearAllUrl = () => {
  const drawerClear = document.querySelector('#FilterDrawerRemove .facets__remove-button--clear');
  if (drawerClear) return drawerClear.getAttribute('href');

  const url = new URL(window.location.href);
  const keysToDelete = [];

  url.searchParams.forEach((value, key) => {
    if (key.startsWith('filter.') || key === 'page') {
      keysToDelete.push(key);
    }
  });

  keysToDelete.forEach((key) => {
    url.searchParams.delete(key);
  });

  return `${url.pathname}${url.search}${url.hash}`;
};

const syncTopFilterClearAll = () => {
  const topRemove = document.getElementById('FilterRemove');
  if (!topRemove) return;

  const allFiltersButton = topRemove.querySelector('.facets__remove-button[data-quick-access="all"]');
  const existingTopClear = topRemove.querySelector('.js-top-filter-clear-all');
  const hasActiveFilters = Boolean(
    document.querySelector('#FilterDrawerRemove .facets__remove-button--clear')
      || topRemove.querySelector('.facets__remove-button[data-filter-handle].is-active')
      || (allFiltersButton && allFiltersButton.querySelector('.facets__remove-button-count'))
  );

  if (!hasActiveFilters) {
    if (existingTopClear) existingTopClear.remove();
    return;
  }

  const clearAllUrl = getTopFilterClearAllUrl();
  if (!clearAllUrl) return;

  if (existingTopClear) {
    existingTopClear.setAttribute('href', clearAllUrl);
    return;
  }

  topRemove.insertAdjacentHTML(
    'beforeend',
    `<a href="${clearAllUrl}" class="facets__remove-button body body--small-mobile facets__remove-button--clear js-top-filter-clear-all">Clear all</a>`
  );
};

const initTopFilterClearAll = () => {
  const topClearAll = document.querySelector('#FilterRemove .js-top-filter-clear-all');
  if (!topClearAll || topClearAll.dataset.bound === 'true') return;

  topClearAll.dataset.bound = 'true';
  topClearAll.addEventListener('click', (event) => {
    const form = document.querySelector('facet-filters-form');
    if (!form || typeof form.onActiveFilterClick !== 'function') return;
    form.onActiveFilterClick(event);
  });
};

const initFacetsQuickAccess = () => {
  const quickAccessLinks = document.querySelectorAll('.facets-quick-access__link');
  if (!quickAccessLinks.length) return;

  const menuDrawer = document.querySelector('#FacetsDrawer');
  const trigger = document.querySelector('[aria-controls="FacetsDrawer"]');

  const clearHighlights = () => {
    if (!menuDrawer) return;
    menuDrawer.querySelectorAll('.filter__group').forEach((group) => {
      group.classList.remove('filter__group--highlight');
      group.removeAttribute('open');
    });
  };

  const openFilterGroup = (handle, label) => {
    if (!menuDrawer) return;

    const safeHandle = window.CSS && CSS.escape ? CSS.escape(handle) : handle;
    let target = menuDrawer.querySelector(`.filter__group[data-filter-handle=\"${safeHandle}\"]`);

    if (!target && label) {
      const safeLabel = window.CSS && CSS.escape ? CSS.escape(label) : label;
      target = menuDrawer.querySelector(`.filter__group[data-filter-label=\"${safeLabel}\"]`);
    }

    if (!target) return;

    target.setAttribute('open', '');
    target.classList.add('filter__group--highlight');

    const summary = target.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', true);

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (trigger) {
    trigger.addEventListener('click', () => {
      clearHighlights();
    });
  }

  quickAccessLinks.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      clearHighlights();

      const quickAccessList = button.closest('.facets-quick-access__list');
      if (quickAccessList) {
        quickAccessList.style.transform = 'none';
        quickAccessList.style.transition = 'none';
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }

      // Always open drawer if not open
      if (trigger && !document.body.classList.contains('menu-drawer-open')) {
        trigger.click();
      }

      // For collection, highlight the matching group in the drawer
      if (button.dataset.quickAccess === 'collection') {
        setTimeout(() => {
          openFilterGroup(button.dataset.filterHandle, button.dataset.filterLabel);
        }, 80);
        return;
      }

      setTimeout(() => {
        openFilterGroup(button.dataset.filterHandle, button.dataset.filterLabel);
      }, 80);
    });
  });
};

const initFacetsFilterList = () => {
  const filterButtons = document.querySelectorAll('.facets__remove-button[data-filter-handle]');
  const allFiltersButton = document.querySelector('.facets__remove-button[data-quick-access="all"]');
  if (!filterButtons.length && !allFiltersButton) return;

  const menuDrawer = document.querySelector('#FacetsDrawer');
  const trigger = document.querySelector('[aria-controls="FacetsDrawer"]');

  const openFilterGroup = (handle, label) => {
    if (!menuDrawer) return;

    const safeHandle = window.CSS && CSS.escape ? CSS.escape(handle) : handle;
    let target = menuDrawer.querySelector(`.filter__group[data-filter-handle=\"${safeHandle}\"]`);

    if (!target && label) {
      const safeLabel = window.CSS && CSS.escape ? CSS.escape(label) : label;
      target = menuDrawer.querySelector(`.filter__group[data-filter-label=\"${safeLabel}\"]`);
    }

    if (!target) return;

    target.setAttribute('open', '');
    target.classList.add('filter__group--highlight');

    const summary = target.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', true);

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      if (trigger && !document.body.classList.contains('menu-drawer-open')) {
        trigger.click();
      }

      setTimeout(() => {
        openFilterGroup(button.dataset.filterHandle, button.dataset.filterLabel);
      }, 80);
    });
  });

  if (allFiltersButton) {
    allFiltersButton.addEventListener('click', (event) => {
      event.preventDefault();

      if (trigger && !document.body.classList.contains('menu-drawer-open')) {
        trigger.click();
      }
    });
  }
};

const getRcContentUrlKey = (url) => {
  try {
    const resolvedUrl = new URL(url, window.location.origin);
    return `${resolvedUrl.pathname}${resolvedUrl.search}`;
  } catch (e) {
    return '';
  }
};

const getRcContentFacetSlidePosition = (slider, slide) => {
  if (!slider || !slide) return 0;

  const firstSlide = slider.querySelector('.rc-content-text__item');
  const firstSlideOffset = firstSlide ? firstSlide.offsetLeft : 0;

  return Math.max(0, slide.offsetLeft - firstSlideOffset);
};

const initRcContentActive = () => {
  const links = document.querySelectorAll('[data-rc-content-link]');
  if (!links.length) return;

  const currentKey = getRcContentUrlKey(window.location.href);
  if (!currentKey) return;

  const slidersToReset = new Set();

  links.forEach((link) => {
    const href = link.getAttribute('href');
    const item = link.closest('.content__item, .rc-content-text__item');
    const isActive = !!href && getRcContentUrlKey(href) === currentKey;

    link.classList.toggle('is-active', isActive);

    if (item) {
      item.classList.toggle('slider__slide--initial', isActive);
    }

    if (isActive && item) {
      const sliderComponent = item.closest('slider-component');
      if (!sliderComponent) return;

      sliderComponent.initialSlide = item;
      slidersToReset.add(sliderComponent);
    }
  });

  slidersToReset.forEach((sliderComponent) => {
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const isRcContentTextSlider = slider && slider.classList.contains('rc-content-text__list');

    if (typeof sliderComponent.resetPages === 'function') {
      sliderComponent.resetPages();

      if (isRcContentTextSlider && sliderComponent.initialSlide) {
        const slidePosition = getRcContentFacetSlidePosition(slider, sliderComponent.initialSlide);

        if (typeof sliderComponent.setSlidePosition === 'function') {
          sliderComponent.setSlidePosition(slidePosition);
        } else {
          slider.scrollTo({ left: slidePosition, behavior: 'auto' });
        }
      }

      return;
    }

    if (slider && sliderComponent.initialSlide) {
      const slidePosition = isRcContentTextSlider
        ? getRcContentFacetSlidePosition(slider, sliderComponent.initialSlide)
        : sliderComponent.initialSlide.offsetLeft;

      slider.scrollTo({ left: slidePosition, behavior: 'auto' });
    }
  });
};

// Content-card and banner-in-grid videos (rc_listing's content_cards/content_blocks
// loop) each ship their own inline <script> to force autoplay in Safari, but on this
// grid that per-card script doesn't reliably run for every card. Rather than depend
// on it, force every one of these videos to load+play from here instead — this file
// is a normal external script, so it always runs regardless of what happens per-card.
//
// Cards deep in the grid are off-screen at page-load time, and Safari defers/skips
// resource loading for off-screen media — a plain page-load-time load()+play() call
// only actually works for cards already in the viewport. Use an IntersectionObserver
// so each video's load()+play() fires once it's actually scrolled near the viewport,
// matching the moment a manual load()+play() from DevTools (with the element already
// scrolled into view) was observed to work.
function ensureContentCardVideoAutoplay(video) {
  if (!video) return;

  // Mirrors CardSwatches.ensureCardVideoAutoplay in this file (product-card
  // videos, proven working) exactly: re-assert these as JS properties, not
  // just HTML attributes, register retry listeners BEFORE play() so they
  // catch playback whenever the browser actually gets around to it (not
  // bounded by a fixed timeout), then load() before the immediate play().
  video.muted = true;
  video.setAttribute('muted', '');
  video.playsInline = true;
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  video.autoplay = true;
  video.setAttribute('autoplay', '');
  video.preload = 'auto';
  video.setAttribute('preload', 'auto');

  const attemptPlay = () => {
    if (!video.isConnected) return;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') playPromise.catch(() => {});
  };

  video.addEventListener('loadeddata', () => { if (video.paused) attemptPlay(); }, { once: true });
  video.addEventListener('canplay', () => { if (video.paused) attemptPlay(); }, { once: true });
  setTimeout(() => { if (video.paused) attemptPlay(); }, 150);
  requestAnimationFrame(() => { if (video.paused) attemptPlay(); });

  if (video.readyState < 2) video.load();

  attemptPlay();
}

// A one-shot IntersectionObserver per video was unreliable here (worked when
// re-invoked manually with the element already on-screen, but its own later
// scroll-triggered callback never fired). Replaced with a plain scroll/resize
// re-check instead — no observer lifecycle to go stale, just re-run this and
// let the paused+in-viewport check gate it, exactly like the manual call that
// was proven to work.
function isNearViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0 && rect.bottom > -200 && rect.top < window.innerHeight + 200;
}

function ensureContentCardVideosPlay() {
  document.querySelectorAll('#product-grid .content__card video, #product-grid .card__banner video').forEach((video) => {
    if (!video.paused) return;
    try {
      if (isNearViewport(video)) ensureContentCardVideoAutoplay(video);
    } catch (e) {
      console.error('[RC] ensureContentCardVideosPlay failed for one video, continuing with the rest:', e);
    }
  });
}

let rcVideoScrollScheduled = false;
function scheduleContentCardVideoCheck() {
  if (rcVideoScrollScheduled) return;
  rcVideoScrollScheduled = true;
  requestAnimationFrame(() => {
    rcVideoScrollScheduled = false;
    ensureContentCardVideosPlay();
  });
}
window.addEventListener('scroll', scheduleContentCardVideoCheck, { passive: true });
window.addEventListener('resize', scheduleContentCardVideoCheck, { passive: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    toggleEmptyFacetsFilters();
    syncTopFilterClearAll();
    initTopFilterClearAll();
    initFacetsQuickAccess();
    initFacetsFilterList();
    initRcContentActive();
    ensureContentCardVideosPlay();
  });
} else {
  toggleEmptyFacetsFilters();
  syncTopFilterClearAll();
  initTopFilterClearAll();
  initFacetsQuickAccess();
  initFacetsFilterList();
  initRcContentActive();
  ensureContentCardVideosPlay();
}
